import React, { useState } from "react";
import styles from "./DayTabs.module.scss";

interface DayTabsProps {
  data: string[];
  activeIndex: number;
  setActiveIndex: (val: number) => void;
}

const DayTabs = ({ data, activeIndex, setActiveIndex }: DayTabsProps) => {
  const handleActiveIndex = (index: number) => {
    activeIndex === index ? setActiveIndex(activeIndex) : setActiveIndex(index);
  };
  return (
    <div className={styles.tabWrapper}>
      <ul className={styles.tabsList}>
        {data.map((element, index) => {
          return (
            <li
              className={activeIndex === index ? `${styles.active}` : ``}
              onClick={() => handleActiveIndex(index)}
            >
              {element}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default DayTabs;
